import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TokenService } from '../services/token/token.service';

@Injectable()
export class RequestInterceptor implements HttpInterceptor {
    constructor(private tokenSvc: TokenService) {}

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler,
    ): Observable<HttpEvent<any>> {
        const requestWithCredentials = req.clone({
            headers: req.headers.set(
                'Authorization',
                `Bearer ${this.tokenSvc.token}`,
            ),
        });
        return next.handle(requestWithCredentials);
    }
}
